import { useT } from "../lib/i18n";
import { SheetShell } from "./SheetShell";
import { Button } from "./ui/Button";

type Props = {
  open: boolean;
  weekNumber: number;
  targetKcal: number;
  onClose: () => void;
};

export function RefeedSheet({ open, weekNumber, targetKcal, onClose }: Props) {
  const t = useT();
  if (!open) return null;
  return (
    <SheetShell onClose={onClose}>
      <div className="space-y-4 pt-2">
        <h2 className="text-lg font-semibold">{t("refeed_sheet.title")}</h2>
        <p className="text-sm text-fg-secondary leading-relaxed">
          {t("refeed_sheet.body", { n: weekNumber, kcal: targetKcal })}
        </p>
        <Button fullWidth onClick={onClose}>
          {t("refeed_sheet.close")}
        </Button>
      </div>
    </SheetShell>
  );
}
